export class WebappSlotSetting {
    public name         : string = '';
    public slotSetting  : boolean = false;
    public value        : string = '';
}

export class EnvSettings {

    readonly _apiHost       : string;
    readonly _mediatorHost  : string;
    readonly _adApiScope    : string;
    readonly _adPolicy      : string;
    readonly _adTenant      : string;
    readonly _adClient      : string;
    readonly _adScope       : string;
    readonly _adInstance    : string;
    readonly _adInstanceUrl : string;
    readonly _adResetPolicy : string;
    readonly _clientUrl     : string;
    readonly _clientEnv     : string;
    readonly _postLogoutUrl : string;
    
    public  constructor(apiHost: string, adApiScope: string, 
        adPolicy: string, adTenant: string, adClient: string, 
        adInstance: string, clientUrl: string, clientEnv: string,
        mediatorHost: string) {

        this._apiHost       = apiHost;
        this._mediatorHost  = mediatorHost;
        this._adApiScope    = adApiScope;
        this._adPolicy      = adPolicy;
        this._adTenant      = adTenant;
        this._adClient      = adClient;
        this._adInstance    = adInstance;
        this._clientUrl     = clientUrl;
        this._clientEnv     = clientEnv;

        // Computed
        this._adInstanceUrl = `https://${ this._adInstance }.b2clogin.com/tfp/`;
        this._adScope       = `https://${ this._adTenant }/${ this._adApiScope }/user_impersonation`;

        // For now we won't have this be env specific
        this._postLogoutUrl = "https://www.chiohd.com/";
        
        // Not currently used
        this._adResetPolicy = '';
    }

}

let AppSettings : EnvSettings = {} as EnvSettings;

function configureEnvironment() {

    const SETTING_API_HOST          = 'Api:Host';
    const SETTING_MEDIATOR_HOST     = 'Mediator:Host';
    const SETTING_AD_API_SCOPE      = 'AZUREAD:SCOPE';
    const SETTING_AD_POLICY         = 'AZUREAD:POLICY';
    const SETTING_AD_TENANTID       = 'AZUREAD:TENANTID';
    const SETTING_AD_CLIENTID       = 'AZUREAD:CLIENTID';
    const SETTING_AD_INSTANCE       = 'AZUREAD:INSTANCE';
    const SETTING_CLIENT_URL        = 'Client:AppHost';
    const SETTING_CLIENT_ENV        = 'Client:Environment';

    return fetch("/env.default.json")
        .then((response) => {
            return response.json();
        })
        .then((json) => {
            if (json && json.length > 0) {

                let apiHost         = '';
                let adApiScope      = '';
                let adPolicy        = '';
                let adTenent        = '';
                let adClient        = '';
                let adInstance      = '';
                let clientUrl       = '';
                let clientEnv       = '';
                let mediatorHost    = '';
                
                json.forEach((itm: WebappSlotSetting) => {
                    if (itm.name === SETTING_API_HOST) {
                        apiHost = itm.value;
                    }
                    else if (itm.name === SETTING_AD_API_SCOPE) {
                        adApiScope = itm.value;
                    }
                    else if (itm.name === SETTING_AD_POLICY){
                        adPolicy = itm.value;
                    }
                    else if (itm.name === SETTING_AD_TENANTID){
                        adTenent = itm.value;
                    }
                    else if (itm.name === SETTING_AD_CLIENTID) {
                        adClient = itm.value;
                    }
                    else if (itm.name === SETTING_AD_INSTANCE) {
                        adInstance = itm.value;
                    }
                    else if (itm.name === SETTING_CLIENT_URL){
                        clientUrl = itm.value;
                    }
                    else if (itm.name === SETTING_CLIENT_ENV){
                        clientEnv = itm.value;
                    }
                    else if (itm.name === SETTING_MEDIATOR_HOST) {
                        mediatorHost = itm.value;
                    }
                });

                AppSettings = new EnvSettings(apiHost, adApiScope, 
                    adPolicy, adTenent, adClient, adInstance, 
                    clientUrl, clientEnv, mediatorHost);                
            }
        });
}

export { AppSettings, configureEnvironment }
